var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4640",
    "data-name": "Raggruppa 4640",
    transform: "translate(-229 -190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4637",
    "data-name": "Raggruppa 4637",
    transform: "translate(55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4632",
    "data-name": "Raggruppa 4632",
    transform: "translate(42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4627",
    "data-name": "Raggruppa 4627",
    transform: "translate(72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2111",
    "data-name": "Rettangolo 2111",
    width: 24,
    height: 24,
    transform: "translate(60 190)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-alt",
    "data-name": "Icon awesome-calendar-alt",
    d: "M0,15.536a1.608,1.608,0,0,0,1.607,1.607H13.393A1.608,1.608,0,0,0,15,15.536V6.429H0ZM10.714,8.973a.4.4,0,0,1,.4-.4h1.339a.4.4,0,0,1,.4.4v1.339a.4.4,0,0,1-.4.4H11.116a.4.4,0,0,1-.4-.4Zm0,4.286a.4.4,0,0,1,.4-.4h1.339a.4.4,0,0,1,.4.4V14.6a.4.4,0,0,1-.4.4H11.116a.4.4,0,0,1-.4-.4ZM6.429,8.973a.4.4,0,0,1,.4-.4H8.17a.4.4,0,0,1,.4.4v1.339a.4.4,0,0,1-.4.4H6.83a.4.4,0,0,1-.4-.4Zm0,4.286a.4.4,0,0,1,.4-.4H8.17a.4.4,0,0,1,.4.4V14.6a.4.4,0,0,1-.4.4H6.83a.4.4,0,0,1-.4-.4ZM2.143,8.973a.4.4,0,0,1,.4-.4H3.884a.4.4,0,0,1,.4.4v1.339a.4.4,0,0,1-.4.4H2.545a.4.4,0,0,1-.4-.4Zm0,4.286a.4.4,0,0,1,.4-.4H3.884a.4.4,0,0,1,.4.4V14.6a.4.4,0,0,1-.4.4H2.545a.4.4,0,0,1-.4-.4ZM13.393,2.143H11.786V.536A.537.537,0,0,0,11.25,0H10.179a.537.537,0,0,0-.536.536V2.143H5.357V.536A.537.537,0,0,0,4.821,0H3.75a.537.537,0,0,0-.536.536V2.143H1.607A1.608,1.608,0,0,0,0,3.75V5.357H15V3.75A1.608,1.608,0,0,0,13.393,2.143Z",
    transform: "translate(234 193)",
    fill: "#2c0000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9db30f4ae1fdfee32acdeb18cf756bb7.svg";
export { ForwardRef as ReactComponent };